import { createRootRouteWithContext, HeadContent, Outlet } from "@tanstack/react-router";
import type { RouterContext } from "@/app/router/context";
import { NotFoundPage } from "@/components/feedback/route-pages";

export const Route = createRootRouteWithContext<RouterContext>()({
  head: () => ({ meta: [{ title: "Rogue Admin" }] }),
  component: () => (
    <>
      <HeadContent />
      <Outlet />
    </>
  ),
  notFoundComponent: () => <NotFoundPage />,
});
